// src/Dashboard/pages/user/FicheAdherent/FicheAdherentDashboard.jsx

import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useUser } from "../../../../pages/Home/UserContext";

import EditAdherentAdminModal from "../../../../pages/PagesAdministrateurs/ListingAdherentsAdmin/EditAdherentAdminModal";

import AdherentHeaderCard from "./components/AdherentHeaderCard";
import AdherentSelector from "./components/AdherentSelector";
import AdherentTabs from "./components/AdherentTabs";
import AdherentTabContent from "./components/AdherentTabContent";
import { useFicheAdherentDashboard } from "./hooks/useFicheAdherentDashboard";

export default function FicheAdherentDashboard() {
  const { user } = useUser();
  const userId = user?.userId;

  const {
    adherents,
    selectedAdherent,
    selectedAdherentId,
    setSelectedAdherentId,
    loading,
    refreshing,
    refreshAdherents,
  } = useFicheAdherentDashboard(userId);

  const [activeTab, setActiveTab] = useState("profil");
  const [isEditOpen, setIsEditOpen] = useState(false);

  const openEditModal = () => {
    if (!selectedAdherent) return;
    setIsEditOpen(true);
  };

  const closeEditModal = () => {
    setIsEditOpen(false);
  };

  return (
    <section className="min-h-screen bg-slate-50 px-4 py-6 dark:bg-slate-950 sm:px-6 lg:px-8">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-6">
        <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
          <div className="relative overflow-hidden bg-slate-950 px-5 py-6 text-white sm:px-7">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(59,130,246,0.35),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(168,85,247,0.28),transparent_36%)]" />

            <div className="relative flex flex-col gap-2">
              <p className="text-xs font-bold uppercase tracking-[0.24em] text-sky-200">
                Mon espace adhérent
              </p>

              <div className="flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
                <div>
                  <h1 className="font-display text-2xl font-bold tracking-tight sm:text-3xl">
                    Fiche adhérent
                  </h1>
                  <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-200">
                    Consultez les informations importantes sans tout afficher
                    d’un coup : profil, groupes, ceintures, dossier, paiements,
                    achats et présences.
                  </p>
                </div>

                <div className="rounded-2xl border border-white/10 bg-white/10 px-4 py-3 text-sm backdrop-blur">
                  <span className="font-bold">{adherents.length}</span>{" "}
                  adhérent{adherents.length > 1 ? "s" : ""} lié
                  {adherents.length > 1 ? "s" : ""} à votre compte
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-6 p-4 sm:p-6">
            <AdherentSelector
              adherents={adherents}
              selectedAdherentId={selectedAdherentId}
              onSelect={(id) => {
                setSelectedAdherentId(id);
                setActiveTab("profil");
              }}
              loading={loading}
            />

            {selectedAdherent ? (
              <>
                <AdherentHeaderCard
                  adherent={selectedAdherent}
                  refreshing={refreshing}
                  onRefresh={refreshAdherents}
                  onEdit={openEditModal}
                />

                <div className="rounded-[26px] border border-slate-200 bg-white p-3 shadow-sm dark:border-slate-800 dark:bg-slate-950">
                  <AdherentTabs activeTab={activeTab} onChange={setActiveTab} />

                  <div className="mt-4">
                    <AdherentTabContent
                      activeTab={activeTab}
                      adherent={selectedAdherent}
                      adherentId={selectedAdherentId}
                      onEdit={openEditModal}
                    />
                  </div>
                </div>
              </>
            ) : (
              <div className="rounded-[26px] border border-dashed border-slate-300 bg-slate-50 p-8 text-center dark:border-slate-700 dark:bg-slate-900/60">
                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-900 text-white dark:bg-white dark:text-slate-900">
                  👤
                </div>
                <h2 className="mt-4 text-lg font-bold text-slate-900 dark:text-white">
                  Aucun adhérent sélectionné
                </h2>
                <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                  Sélectionnez un adhérent pour afficher sa fiche.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      {selectedAdherent && (
        <EditAdherentAdminModal
          isOpen={isEditOpen}
          onClose={closeEditModal}
          adherent={selectedAdherent}
          refreshList={refreshAdherents}
        />
      )}

      <ToastContainer />
    </section>
  );
}